export default () => {
  const showListBtn = document.querySelectorAll(".js-show-list");
  const listItems = document.querySelectorAll(".js-list-item");
  const cardsOffer = document.querySelectorAll(".js-appearCard");

  if (showListBtn) {
    showListBtn.forEach((btn) => {
      btn.addEventListener("click", (ev) => {
        const offerBlock = document.querySelector(".js-list-block");
        const isActive = ev.currentTarget.classList.contains("is-active");

        // Reset all active states
        showListBtn.forEach((item) => item.classList.remove("is-active"));
        listItems.forEach((list) => list.classList.remove("is-active"));
        cardsOffer.forEach((cardOffer) =>
          cardOffer.classList.remove("fade-in-top")
        );
        offerBlock.classList.remove("is-active");

        // If the clicked button was not active, activate it
        if (!isActive) {
          ev.currentTarget.classList.add("is-active");
          offerBlock.classList.add("is-active");

          const findIndex = Array.from(listItems).findIndex((item) => {
            return item.dataset.client == ev.currentTarget.dataset.offerlist;
          });

          if (findIndex !== -1) {
            listItems[findIndex].classList.add("is-active");
          }

          cardsOffer.forEach((cardOffer) => {
            cardOffer.classList.add("fade-in-top");
          });
        }
      });
    });
  }
};
